var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { staticClass: "pb-1 pr-1", attrs: { xs4: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c("v-card-text", { staticClass: "card-bg-1" }, [
                _c(
                  "div",
                  { staticClass: "caption grey--text text--darken-2" },
                  [_vm._v("Time series")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "headline" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.numberWithCommas(_vm.dataSummary.timeSeries)
                        ) +
                        "\n          "
                    ),
                    _c("v-icon", [_vm._v("mdi-clock")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "px-1 pb-1", attrs: { xs4: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c("v-card-text", { staticClass: "card-bg-1" }, [
                _c(
                  "div",
                  { staticClass: "caption grey--text text--darken-2" },
                  [_vm._v("From")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "headline" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.dataSummary.from) +
                        "\n          "
                    ),
                    _c("v-icon", [_vm._v("event")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "pb-1 pl-1", attrs: { xs4: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c("v-card-text", { staticClass: "card-bg-1" }, [
                _c(
                  "div",
                  { staticClass: "caption grey--text text--darken-2" },
                  [_vm._v("To")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "headline" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.dataSummary.to) +
                        "\n          "
                    ),
                    _c("v-icon", [_vm._v("event")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "pt-1 px-0", attrs: { xs12: "" } },
        [
          _c(
            "v-card",
            { staticClass: "max-height elevation-1" },
            [
              _c(
                "v-card-text",
                { staticClass: "card-bg-1" },
                [
                  _c(
                    "div",
                    { staticClass: "caption grey--text text--darken-2" },
                    [_vm._v("Available time series")]
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm.dataSummary.availableTimeSeries /*.slice(0, 10)*/,
                    function (timeSeries, index) {
                      return _c(
                        "v-chip",
                        {
                          key: `timeSeries-${index}`,
                          staticClass: "clickable",
                          attrs: {
                            selected: _vm.isActive(timeSeries),
                            color: _vm.isActive(timeSeries)
                              ? "info lighten"
                              : null,
                            dark: _vm.isActive(timeSeries),
                            small: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setActive(timeSeries)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(timeSeries.displayName) +
                              "\n        "
                          ),
                        ]
                      )
                    }
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }